import { render, staticRenderFns } from "./DeleteMultipleMessages.vue?vue&type=template&id=2b9797a0&scoped=true&lang=pug&"
import script from "./DeleteMultipleMessages.vue?vue&type=script&lang=js&"
export * from "./DeleteMultipleMessages.vue?vue&type=script&lang=js&"
import style0 from "./DeleteMultipleMessages.vue?vue&type=style&index=0&id=2b9797a0&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9797a0",
  null
  
)

export default component.exports